import React from 'react';
import { TileSlider } from '../TileSlider';
import { EventCard as LegacyEventCard, LeagueCard } from '../Cards';
import { EventCard as EventCardV2 } from '../EventCard';
import { SliderCard, EventCard as EventCardType } from '../../contracts';

import './index.scss';

// width of each tile for TileSlider calculations
const legacyFixedTileWidth = 172;
const fixedTileWidth = 188;

export type SliderProps = {
    cards: SliderCard[];
    isEventSliderRedesign: boolean;
    onClick: (id: string, name: string, isSgp: boolean) => void;
};

export type Slidertate = {
    sliderWidth: number;
};
export class Slider extends React.Component<SliderProps, Slidertate> {
    static defaultProps = {
        widgets: []
    };

    parentRef: HTMLDivElement | null = null;

    constructor(props: SliderProps) {
        super(props);

        this.state = {
            sliderWidth: 0
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.setWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setWidth);
    }

    setParentRef = (r: HTMLDivElement) => {
        if (!this.parentRef && r) {
            this.parentRef = r;
            this.setState({ sliderWidth: r.offsetWidth });
        }
    };

    setWidth = () => {
        if (this.parentRef) {
            this.setState({ sliderWidth: this.parentRef.offsetWidth });
        }
    };

    createWidgetCards = (cards: SliderCard[]) => {
        return cards.map((card: SliderCard) => {
            if (card.type === 'event') {
                const handleClick = (e: React.MouseEvent) => {
                    e.preventDefault();
                    this.props.onClick(card.id, card.name, false);
                };

                if (this.props.isEventSliderRedesign) {
                    return <EventCardV2 key={card.id} {...card} onClick={handleClick} />;
                }

                return (
                    <LegacyEventCard
                        key={card.id}
                        {...card}
                        onClick={handleClick}
                        onSgpClick={(e) => this.onCardSGPClick(e, card)}
                    />
                );
            }

            return <LeagueCard key={card.id} {...card} />;
        });
    };

    // TODO: kept for Legacy Widget Slider - to be removed with Legacy Home Page/Widget Slider deprecation
    onCardSGPClick = (e: React.MouseEvent, card: EventCardType) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onClick(card.id, card.name, true);
    };

    getFixedTileWidth = () => {
        return this.props.isEventSliderRedesign ? fixedTileWidth : legacyFixedTileWidth;
    };

    render() {
        const { cards } = this.props;
        const fixedTileWidth = this.getFixedTileWidth();

        const tiles = this.createWidgetCards(cards);

        return (
            <div className="slider-cards" data-testid="slider-cards" ref={this.setParentRef}>
                <TileSlider
                    sliderWidth={this.state.sliderWidth + 200}
                    tileWidth={200}
                    scrollMode={this.state.sliderWidth <= 768}
                    tileWidths={tiles.map(() => fixedTileWidth)}
                    dynamicSlide
                    offset={0}
                    shouldCalculateContainerWidth
                    arrowDisplay=""
                    isEventSliderRedesign={this.props.isEventSliderRedesign}
                >
                    {tiles}
                </TileSlider>
            </div>
        );
    }
}
